'use client';

import { Field, Label, Switch } from '@ctct/summit-core';
import { type ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';

const SwitchInput = ({
  formKey,
  registerOpts,
  switchLabel,
  className,
  ...inputProps
}: InputOpts
  & ComponentProps<typeof Switch> & {
    switchLabel?: string;
  }) => {
  const { control } = useFormContext();
  return (
    <Field kind="inline-switch" id={formKey} className={className}>
      <Controller
        name={formKey}
        control={control}
        rules={registerOpts}
        render={({ field: { onChange: handleChange, value } }) => {
          return (
            <Switch {...inputProps} id={formKey} checked={!!value} onCheckedChange={handleChange} />
          );
        }}
      />
      <Label className="r:text-xs">{switchLabel}</Label>
    </Field>
  );
};

export { SwitchInput };
